import React, { useState } from 'react';
import { Dropdown, Menu } from 'antd';
import { withApollo } from 'react-apollo';
import moment from 'moment';
import { assign, get, includes } from 'lodash';
import { number, bool, object, func, array, string } from 'prop-types';
import { HasPermissions, Loading, FlexContainer, Button, Row, Text, Icon, MenuWithPermissions } from '../../../components/common';
import MassiveActions from './MassiveActions';
import ModalActions from './ModalActions';
import { GET_ORDERS } from '../../../queries';
import EXPORT_BACKPACK_REPORT from '../../graphql/exportBackpackReport';

const limitMsgOrdersExport = () => {
    const color = '#ff0000';

    return (
        <Row align='center' style={{ minWidth: 300 }}>
            <Icon name='caution' size={15} color={color} style={{ margin: 5 }} />
            <Text color={color} text='Máximo permitido a exportar&nbsp;' />
            <Text color={color} text='100.000&nbsp;' strong />
            <Text color={color} text='registros' />
        </Row>
    );
};

const RightHeader = ({
    ordersCount,
    loadingBtnExport,
    client,
    filteredVariables,
    variables,
    session,
    selectedOrders,
    action,
    setAction,
    orderData,
    setOpened,
    setRefreshRightHeader,
    refreshRightHeader,
    getSessionSalesChannelById
}) => {
    const [visibleModal, setVisibleModal] = useState(false);
    const [typeReport, setTypeReport] = useState(0);

    const callExportQuery = (type) => {
        if (includes([1, 5], type)) {
            const rescheduleVariables = {
                filters: {
                    field: 'salesChannelId',
                    value: getSessionSalesChannelById
                },
                range: {
                    init: moment(moment()).subtract(1, 'day').format('YYYY-MM-DD 00:00:00'),
                    end: moment(moment()).format('YYYY-MM-DD HH:mm:ss'),
                    filter: 'detail.shippingData.logisticsInfo.shippingETA.init'
        
                }
            };

            return client.query({
                query: GET_ORDERS,
                variables: assign(type === 5 ? rescheduleVariables : filteredVariables(variables), { sendToExport: get(session, 'email'), typeReport: type }),
                fetchPolicy: 'network-only'
            });
        };
        return client.query({ query: EXPORT_BACKPACK_REPORT, variables: { sendToExport: get(session, 'email') }, fetchPolicy: 'network-only' });
    };

    const renderModalExport = (type) => {
        setTypeReport(type);
        setVisibleModal(true);
    };

    const limitOrdersToExport = 100000;
    const disabledOrderExport = !(ordersCount > 0) || ordersCount >= limitOrdersToExport;
    const menuTypeReport = (
        <MenuWithPermissions>
            <Menu.Item key='1' onClick={() => renderModalExport(1)} disabled={disabledOrderExport}>
                Pedidos
            </Menu.Item>
            <Menu.Item key='2' onClick={() => callExportQuery(5).then(() => renderModalExport(5))}>
                Reprogramación
            </Menu.Item>
            <HasPermissions to={['orders-page:backpack-report']}>
                <Menu.Item key='3' onClick={() => callExportQuery(6).then(() => renderModalExport(6))}>
                    Mochilas
                </Menu.Item>
            </HasPermissions>
        </MenuWithPermissions>
    );

    return (
        <>
            <HasPermissions to={['orders-page:massive-scheduling']}>
                <MassiveActions
                    run={() => {}}
                    selectedOrders={selectedOrders}
                    action={action}
                    setAction={setAction}
                    setOpened={setOpened}
                    selectedSla={get(orderData, 'logisticsInfo.selectedSla')}
                />
            </HasPermissions>
            <HasPermissions to={['orders-page:export']}>
                <FlexContainer style={{ padding: `${loadingBtnExport && '0px 25px'}` }} direction='column'>
                    <Loading loading={loadingBtnExport}>
                        <FlexContainer direction='row'>
                            {ordersCount >= limitOrdersToExport && limitMsgOrdersExport()}
                            <ModalActions
                                ordersCount={ordersCount}
                                typeReport={typeReport}
                                setVisibleModal={setVisibleModal}
                                visibleModal={visibleModal}
                                callExportQuery={callExportQuery}
                                setRefreshRightHeader={setRefreshRightHeader}
                                refreshRightHeader={refreshRightHeader}
                            />
                            <Dropdown onClick={() => {}} overlay={menuTypeReport}>
                                <Button width={100} secondary text='Reportes' />
                            </Dropdown>
                        </FlexContainer>
                    </Loading>
                </FlexContainer>
            </HasPermissions>
        </>
    );
};

RightHeader.propTypes = {
    ordersCount: number,
    loadingBtnExport: bool,
    client: object,
    filteredVariables: func,
    variables: object,
    session: object,
    selectedOrders: array,
    action: string,
    setAction: func,
    orderData: object,
    setOpened: func,
    setRefreshRightHeader: func,
    refreshRightHeader: bool
};

export default withApollo(RightHeader);
